module.exports = __webpack_public_path__ + "img/android.276cce2b.png";